export const sendGAEvent = (eventName, params) => {
	if (window.gtag) {
		window.gtag('event', eventName, { ...params });
	} else {
		console.debug(
			`Analytics: window.gtag not found - if it were enabled the ${eventName} event would be fired.`
		);
	}
};
